module.exports = __webpack_public_path__ + "static/img/Zheng-Yin_2017-18.49b7367.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Zheng-Yin_2017-18.jpg
// module id = qgqs
// module chunks = 0